var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ac-dropdown',{attrs:{"split":_vm.split,"items":_vm.items,"dropdown_header":_vm.dropdownHeader},on:{"d_item_clicked":_vm.dropdownClick}})}
var staticRenderFns = []

export { render, staticRenderFns }